import { useState } from "react";
import logo from "../assets/img/bharatrohan.png";
import { PowerIcon, MenuIcon, X } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const currentTab = query.get("tab") || "analytics";

  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    navigate('/signin');
  };

  return (
    <>
    <header className="relative flex justify-between items-center px-4 py-2 m-3 bg-white bg-opacity-20 backdrop-blur-md rounded-3xl shadow-md z-[10]">

      {/* Left: Logo */}
      <div className="flex items-center">
        <img className="h-[50px] w-auto" src={logo} alt="logo" />
      </div>

      {/* Center: Tabs (hidden on small screens) */}
      <nav className="hidden md:flex gap-8 items-center text-white text-md">
        <button
          className={`${currentTab === 'analytics' ? "border-b-2 border-yellow-300" : "hover:border-b-2 hover:border-yellow-300"} p-2 px-3`}
          onClick={() => navigate('/dashboard?tab=analytics')}
        >
          Analytics
        </button>
        <button
          className={`${currentTab === 'map' ? "border-b-2 border-yellow-300" : "hover:border-b-2 hover:border-yellow-300"} p-2 px-3`}
          onClick={() => navigate('/dashboard?tab=map')}
        >
          Maps
        </button>
        <button
          className={`${currentTab === 'farmers' ? "border-b-2 border-yellow-300" : "hover:border-b-2 hover:border-yellow-300"} p-2 px-3`}
          onClick={() => navigate('/dashboard?tab=farmers')}
        >
          Farmers
        </button>
      </nav>

      {/* Right: Logout + Mobile Menu Toggle */}
      <div className="flex items-center gap-4">
        {/* Mobile menu button */}
        <button
          className="md:hidden text-white"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={24} /> : <MenuIcon size={24} />}
        </button>

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="bg-yellow-300 hover:bg-yellow-400 text-green p-3 rounded-full text-sm shadow-md"
        >
          <PowerIcon />
        </button>
      </div>

    </header>

    {menuOpen && (
    <div className="fixed top-[80px] right-4 z-[99999] bg-white bg-opacity-95 shadow-lg rounded-xl p-4 w-48 flex flex-col gap-3 md:hidden">
      <button onClick={() => { navigate('/dashboard?tab=analytics'); setMenuOpen(false); }} className="text-green-900 text-sm text-left">Analytics</button>
      <button onClick={() => { navigate('/dashboard?tab=map'); setMenuOpen(false); }} className="text-green-900 text-sm text-left">Maps</button>
      <button onClick={() => { navigate('/dashboard?tab=farmers'); setMenuOpen(false); }} className="text-green-900 text-sm text-left">Farmers</button>
    </div>
  )}
    </>
  );
};

export default Header;
